import { t } from "@lingui/macro";
import { RouteProp, useRoute } from "@react-navigation/native";
import { createNativeStackNavigator } from "@react-navigation/native-stack";
import React from "react";

import { InstructorDetailScreen } from "../../screens/Lessons/screens/InstructorDetail";
import { LessonsScreen } from "../../screens/Lessons/screens/Lessons";
import { ClubStackNavigatorParamList } from "../ClubNavigator";
import { LessonsStackNavigatorParamList } from "./types";

const Stack = createNativeStackNavigator<LessonsStackNavigatorParamList>();

export const LessonsStackNavigator = () => {
  const route = useRoute<RouteProp<ClubStackNavigatorParamList, "Lessons">>();

  const facilitySlug = route?.params ? route.params.facilitySlug : undefined;

  return (
    <Stack.Navigator
      initialRouteName="LessonsHome"
      screenOptions={() => ({
        headerShown: false,
      })}
    >
      <Stack.Screen
        name={"LessonsHome"}
        component={LessonsScreen}
        options={{ headerShown: false, title: t`Lessons` }}
        initialParams={{ facilitySlug }}
      />
      <Stack.Screen
        name={"InstructorDetail"}
        component={InstructorDetailScreen}
        options={{ headerShown: false, title: t`Instructor` }}
        initialParams={{ facilitySlug }}
      />
    </Stack.Navigator>
  );
};
